<template>
    <el-dialog class="mediatbook" :title="diatorTitle" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" width="880px">
        <div class="userParyLoading" v-loading="userParyLoading">
        <!-- 承诺书 -->
        <div v-if="dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&& partybookbVisual">
            <div class="md-otwrap">
                <el-form :model="promiseResponse" ref="promiseForm" label-width="auto" :disabled="true">
                    <el-form-item :label="roleType=='APPLICANT'?('申请人：'+promiseResponse.confirmName):roleType=='RESPONDENT'?('被申请人：'+promiseResponse.confirmName):('申请人：'+promiseResponse.confirmName)" label-width="auto">
                        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 6}" v-model="promiseResponse.content" readonly></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <div v-if="buttonPromiseResult == null">
                    <el-button type="primary" @click="partyConfirmBook('y')" :disabled="buttonStatus">同意</el-button><el-button type="primary" @click="partyConfirmBook('n')" :disabled="buttonStatus">拒绝</el-button>
                </div>
                <div v-if="buttonPromiseResult == 'SIGN_NO'">
                    <el-button type="primary" class="linearbtn">已拒绝</el-button>
                </div>
            </div>
        </div>
        <!-- END -->
        <!-- 协议书 -->
        <div v-if="dialogType == 'MEDIATION_BOOK' || dialogType == 'MEDIATION_RECORD' || dialogType == 'SEND_RECEIPT' || dialogType == 'UNDISPUTED_FACT' || dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&&!partybookbVisual&&!dissentStatus">
            <!-- <el-form :model="protocolBookData" ref="ruleForm" label-width="100px" class="demo-ruleForm" size="small" :disabled="true">
                <div class="caseno"><el-input placeholder="请输入内容" v-model="protocolBookData.caseNo" size="small"></el-input> 号</div>
                <div class="applicanlistscroll">
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="md-head"><span>申请方</span></div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="md-head"><span>被申请方</span></div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.applicantList" :key="`applicant-${index}`">
                                    <el-form-item :label="protocolBookData.applicantList.length>1?('申请人'+(index+1)):'申请人'">
                                        <el-input v-model="item.userName"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'" label="法定代表人">
                                        <el-input v-model="item.corporation"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='UNINCORPORATED_ORGANIZATION'" label="机构代表人">
                                        <el-input v-model="item.corporation"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'||item.userType=='UNINCORPORATED_ORGANIZATION'" label="社会信用代码">
                                        <el-input v-model="item.creditCode"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input type="textarea" :rows="1" v-model="item.address"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号">
                                        <el-input v-model="item.idCard"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别">
                                        <el-radio-group v-model="item.sex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.appAgentList" :key="`appAgent-${index}`">
                                    <el-form-item label="代理人">
                                        <el-input v-model="item.agentName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系电话">
                                        <el-input v-model="item.agentPhone"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号">
                                        <el-input v-model="item.agentIdCard"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别">
                                        <el-radio-group v-model="item.agentSex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="联系地址">
                                        <el-input v-model="item.agentCompany" placeholder="请输入联系地址"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="md-wrap">
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.respondentList" :key="`respondent-${index}`">
                                    <el-form-item :label="protocolBookData.respondentList.length>1?('被申请人'+(index+1)):'被申请人'">
                                        <el-input v-model="item.userName"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'" label="法定代表人">
                                        <el-input v-model="item.corporation"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='UNINCORPORATED_ORGANIZATION'" label="机构代表人">
                                        <el-input v-model="item.corporation"></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="item.userType=='JURIDICAL_PERSON'||item.userType=='UNINCORPORATED_ORGANIZATION'" label="社会信用代码">
                                        <el-input v-model="item.creditCode"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input type="textarea" :rows="1" v-model="item.address"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号">
                                        <el-input v-model="item.idCard"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别" prop="sex">
                                        <el-radio-group v-model="item.sex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                                <div class="applicantlist_line" v-for="(item,index) in protocolBookData.resAgentList" :key="`resAgent-${index}`">
                                    <el-form-item label="代理人">
                                        <el-input v-model="item.agentName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系电话">
                                        <el-input v-model="item.agentPhone"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号">
                                        <el-input v-model="item.agentIdCard"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别">
                                        <el-radio-group v-model="item.agentSex">
                                        <el-radio label="MALE">男</el-radio>
                                        <el-radio label="FEMALE">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input v-model="item.agentCompany" placeholder="请输入联系地址"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div v-if="dialogType == 'MEDIATION_BOOK'">
                        <div class="md-otwrap">
                            <el-form-item label="纠纷主要事实，争议事项：" label-width="auto">
                                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="protocolBookData.content"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div v-if="dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&& !partybookbVisual">
                        <div class="md-otwrap">
                            <el-form-item label="当事人已书面同意本调解组织适用无异议调解认可制度。先就本纠纷提出以下调解方案：" label-width="auto" class="label_textalign">
                            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="protocolBookData.content"></el-input>
                            </el-form-item>
                            <label>{{protocolBookData.extendJson}}</label>
                        </div>
                    </div>
                    <div v-if="dialogType == 'UNDISPUTED_FACT'">
                        <div class="md-otwrap">
                            <el-form-item label="调解过程：" label-width="auto">
                                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="protocolBookData.content"></el-input>
                            </el-form-item>
                            <el-form-item label="经调解，当事人无争议的事实如下：" label-width="auto">
                                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="protocolBookData.extendJson"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
            <div v-if="dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&&!ishelper&&!comdata.istemporary" slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitDissent" class="linearbtn">有异议</el-button>
            </div>
            <div v-else-if="!comdata.istemporary" slot="footer" class="dialog-footer">
                <div v-if="buttonResult == null">
                    <el-button type="primary" @click="agreeBookForm('ruleForm')" class="linearbtn" :disabled="buttonStatus" :loading="BtnLoading">同意</el-button><el-button type="primary" @click="refuseBookForm('ruleForm')" :disabled="buttonStatus" :loading="BtnLoading">拒绝</el-button>
                </div>
                <div v-if="buttonResult == 'SIGN_YES'||buttonResult == 'SIGN_YES_AGENT'">
                    <el-button type="primary" class="linearbtn">已同意</el-button>
                </div>
                <div v-if="buttonResult == 'SIGN_NO'||buttonResult == 'SIGN_NO_AGENT'">
                    <el-button type="primary" class="linearbtn">已拒绝</el-button>
                </div>
            </div> -->
            <div>
                <div v-for="item in recordAttaList" :key="item.index" type="flex" class="row-bg recordAttaList" justify="space-between">
                    <el-row v-if="item.sign === 'ARBITRATION_BOOK' && RECORD_MEDIATIONBOOK_type === 'MEDIATION_BOOK'"><el-col :span="18"><span class="upload_img">{{item.fileName}}</span></el-col>
                        <el-col :span="6"><el-button type="text" icon="el-icon-download" @click="downRecordFile(item)" circle></el-button></el-col>
                    </el-row>
                    <el-row v-if="item.sign === 'MEDIATION_RECORD' && RECORD_MEDIATIONBOOK_type === 'MEDIATION_RECORD'"><el-col :span="18"><span class="upload_img">{{item.fileName}}</span></el-col>
                        <el-col :span="6"><el-button type="text" icon="el-icon-download" @click="downRecordFile(item)" circle></el-button></el-col>
                    </el-row>
                    <el-row v-if="item.sign === 'SEND_RECEIPT' && RECORD_MEDIATIONBOOK_type === 'SEND_RECEIPT'"><el-col :span="18"><span class="upload_img">{{item.fileName}}</span></el-col>
                        <el-col :span="6"><el-button type="text" icon="el-icon-download" @click="downRecordFile(item)" circle></el-button></el-col>
                    </el-row>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div v-if="buttonResult == null">
                        <el-button type="primary" @click="agreeBookForm()" class="linearbtn" :disabled="buttonStatus" :loading="BtnLoading">同意</el-button>
                        <!-- <el-button type="primary" @click="refuseBookForm()" :disabled="buttonStatus" :loading="BtnLoading">拒绝</el-button> -->
                    </div>
                    <div v-if="buttonResult == 'SIGN_YES'||buttonResult == 'SIGN_YES_AGENT'">
                        <el-button type="primary" class="linearbtn">已同意</el-button>
                    </div>
                    <div v-if="buttonResult == 'SIGN_NO'||buttonResult == 'SIGN_NO_AGENT'">
                        <el-button type="primary" class="linearbtn">已拒绝</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- END -->
        <!-- 异议书 -->
        <div class="dissentDialog" v-if="dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&&dissentStatus">
            <el-form :model="dissentData" ref="dissentForm" label-width="80px" class="demo-ruleForm">
                <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="8">
                        <el-form-item label="异议人" prop="userName"
                        :rules="[{ required: true, message: '请输入申请人姓名', trigger: 'blur' }]">
                            <el-input v-model="dissentData.userName" placeholder="请输入异议人姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="性别" prop="sex" label-width="60px">
                            <el-radio-group v-model="dissentData.sex">
                            <el-radio label="MALE">男</el-radio>
                            <el-radio label="FEMALE">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="身份证号" prop="idCard"
                        :rules="[
                            { required: true, message: '请输入身份证号', trigger: 'blur' },
                            { len: 18, message: '请输入18位身份证号', trigger: 'blur' },
                            { pattern: /^\d{17}[\d|x|X]{1}$/, message: '身份证号不正确', trigger: 'blur'}
                        ]">
                            <el-input v-model="dissentData.idCard" placeholder="请输入身份证号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row type="flex" class="row-bg">
                    <el-col :span="12">
                        <el-form-item label="住址" prop="areaarray"
                        :rules="[{ required: true, message: '请选择省市区', trigger: 'change' }]">
                            <areaselect style="width:100%" v-model="dissentData.areaarray" :comtransmit="{'index':'1','type':'dissent'}" @comcallback="comAreaBack"></areaselect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="address"
                        :rules="[{ required: true, message: '请填写详细地址', trigger: 'blur' }]">
                            <el-input v-model="dissentData.address" placeholder="请填写详细地址"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="md-otwrap">
                    <el-form-item label="异议描述：" label-width="auto" class="label_textalign" prop="content"
                    :rules="[{ required: true, message: '请填写详细内容', trigger: 'blur' }]">
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="dissentData.content" placeholder="请填写详细内容"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sendDissentForm('dissentForm')" :loading="BtnLoading" :disabled="buttonStatus">{{dissentSendStatus?'已发送':'发送'}}</el-button><el-button type="primary" @click="saveDissentForm('dissentForm')" :loading="saveBtnLoading" :disabled="buttonStatus">{{Boolean(documentId)&&dissentBtnStatus?'已保存':'保存'}}</el-button>
            </div>
        </div>
        </div>
        <!-- END -->
        <!-- 二维码 -->
        <el-dialog
            width="345px"
            title="扫描二维码"
            :visible.sync="innerVisible"
            :close-on-click-modal=false
            :before-close="handleClose"
            append-to-body>
            <img :src="weixincode">
            <p style="padding: 10px 0">您的调解已完成，若对于笔录/调解协议，无异议，请用微信扫描二维码，前往微信小程序，进行手写签名确认操作，以确保您的合法权益</p>
            <!-- <div class="dialog-footer">
                <el-button type="primary" class="linebtn" @click="sendout('innerVisible')">已经完成手写签名</el-button>
            </div> -->
        </el-dialog>
    </el-dialog>
</template>
<script>
// import areaselect from './areaSelect.vue'
import filedownload from '@/utils/filedown.js'
import areaselect from '@/views/meeting/components/areaSearch/areaSelect.vue'
import {clerkRecordAttaList, getArbitrationBookByUser, getProtocolBook, clerkConfirmQrCode, getMediationScheme, viewMediationPromise, confirmMediationPromise, refuseMediationPromise, viewMediationDissent, sendMediationDissent, saveMediationDissent, agreeProtocolBook, refuseProtocolBook, getMediationClerkConfirm, getAllMediationClerkConfirm} from '@/api/meeting'
export default {
    model: {
        prop: 'comdata',
        event: 'callbackarea'
    },
    data() {
        return {
            // saasconfig:saasconfig,
            saveBtnLoading:false,
            BtnLoading:false,
            dialogVisible: false, // 显示弹窗
            dialogType: '', // 显示哪个内容弹窗
            diatorTitle: '',
            partybookbVisual: true, // 未同意承诺书显示
            caseId: '',
            meetingId: '',
            protocolBookData: {},
            dissentData: {
                areaarray:[]
            },
            promiseResponse: {},
            mediationSchemeResponse: '',
            weixincode: '',
            buttonStatus: false,
            innerVisible: false, // 显示二维码弹窗
            ismediator: true, // 当前角色是否是调解员
            ishelper: false, // 当前角色是否是协助调解员
            roleType: '', // 是申请人还是被申请人
            promiseDocumentId: '', // 协议文书ID
            dissentStatus: false, // 异议书显示
            dissentBtnStatus: false,
            documentId: '', // 协议文书ID
            buttonResult: null,
            buttonPromiseResult: null,
            formaddress: {
                'NATURAL_PERSON':'常住地址',
                'JURIDICAL_PERSON':'单位地址',
                'UNINCORPORATED_ORGANIZATION':'机构地址'
            },
            dissentSendStatus:false,
            userParyLoading: true,
            recordAttaList: [], //获取调解笔录
            RECORD_MEDIATIONBOOK_type: '',
            // 定时器
            timer: null
        }
    },
    components: {
        'areaselect':areaselect
    },
    props:['comdata'],
    mounted() {
        this.ismediator = this.comdata.mediatorself
    },
    watch: {
        innerVisible: function(value) {
            console.log(value, 'watch', this.dialogType)
            if(this.dialogType == "MEDIATION_BOOK" || this.dialogType == "MEDIATION_RECORD" || this.dialogType == "SEND_RECEIPT") {
                if (value) {
                    this.timer = setInterval(this.updateRecordSignStatusRepeat, 2000)
                } else {
                    window.clearInterval(this.timer)
                }
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        openDialog(type,title,caseid,currentCaseUserType, meetingID=null) {
            this.roleType = this.comdata.roleType
            this.caseId = caseid
            this.meetingId = meetingID
            this.dialogType = type
            this.diatorTitle = title
            this.dialogVisible = true
            if(type == "MEDIATION_BOOK" || type == "MEDIATION_RECORD" || type == "SEND_RECEIPT") {
                // this.getBookData('MEDIATION_BOOK')
                this.RECORD_MEDIATIONBOOK_type = type
                this.buttonResult = null
                this.handleRecordAttaList(meetingID)
            }else if(type == "NO_DISSENT_MEDIATION_SCHEME") {
                if(currentCaseUserType == 'MEDIATOR_HELP'||this.comdata.istemporary) {
                    this.partybookbVisual = false
                    this.ishelper = true
                    this.getBookData('NO_DISSENT_MEDIATION_SCHEME')
                }else{
                    this.getScheme()
                }
            }else if(type == 'UNDISPUTED_FACT') {
                this.getBookData('UNDISPUTED_FACT')
            }
        },
        currentSignStatus () {
            let self = this
            getAllMediationClerkConfirm({
                "docmentId": this.documentId,
                "lawCaseId": this.caseId,
            },self.comdata.istemporary).then((res) => {
                if(res.data.code === 1000) {
                    res.data.data.forEach(item => {
                        if (item.userId == self.comdata.userID||item.agentId == self.comdata.userID) {
                            self.buttonResult = item.confirm
                        }
                    })
                }
            })
        },
        getBookData(type) { // 当事人获取协议书
            let self =this, applist=[],reslist=[]
            this.resetComponentAreaData()
            // getArbitrationBookByUser({
            //     caseId: this.caseId,
            //     meetingId: this.meetingId,
            // },self.comdata.istemporary).then((res) => {
            //     if(res.data.code===1000){
            //         this.protocolBookData = res.data.data
            //         this.documentId = res.data.data.protocolId
            //         // if(saasconfig.appname === 'zhengzhouodr' ){
            //         //     this.mediationSchemeId = res.data.data.protocolId
            //         // } else {
            //             this.mediationSchemeId = this.dialogType == 'NO_DISSENT_MEDIATION_SCHEME'?res.data.data.protocolId:''
            //         // }
            //         this.currentSignStatus()
            //     }else {
            //         this.$message.error(res.data.message)
            //     }
            //     this.userParyLoading = false
            // },(error)=>{
            //     console.log(error)
            // })
        },
        getScheme() { // 获取承诺书
            let self = this, applist=[],reslist=[]
            this.resetComponentAreaData()
            viewMediationPromise({
                "lawCaseId": this.caseId
            },self.comdata.istemporary).then((res) => {
                if(res.data.code===1000){
                    if(res.data.data.confirm == null){
                        this.userParyLoading = false
                        this.buttonPromiseResult = null
                        this.promiseResponse = res.data.data
                        this.diatorTitle = '无异议调解方案承诺书'
                        this.documentId = res.data.data.documentId
                    }else if(res.data.data.confirm == 'SIGN_NO'||res.data.data.confirm == 'SIGN_NO_AGENT'){
                        this.userParyLoading = false
                        this.buttonPromiseResult = 'SIGN_NO'
                        this.promiseResponse = res.data.data
                        this.diatorTitle = '无异议调解方案承诺书'
                    }else if(res.data.data.confirm == 'SIGN_YES'||res.data.data.confirm == 'SIGN_YES_AGENT'){
                        viewMediationDissent({"lawCaseId": self.caseId},self.comdata.istemporary).then((res) => {
                            self.documentId = res.data.data.documentId
                            self.dissentBtnStatus = Boolean(res.data.data.content)
                            if(Boolean(res.data.data.documentId)&&Boolean(res.data.data.content)){
                                self.userParyLoading = false
                                self.diatorTitle = '异议书'
                                self.dissentStatus = true
                                self.partybookbVisual = false
                                self.dissentData = res.data.data
                                self.dissentData.areaarray = Array(res.data.data.provCode,res.data.data.cityCode,res.data.data.areaCode,res.data.data.streetCode);
                                getProtocolBook({"caseId": self.caseId,"documentType": 'NO_DISSENT_MEDIATION_SCHEME'},self.comdata.istemporary).then((res) => {
                                    self.mediationSchemeId = res.data.data.protocolId
                                });
                                getMediationClerkConfirm({"docmentId": res.data.data.documentId,"lawCaseId": self.caseId,},self.comdata.istemporary).then((response) => {
                                    if(Boolean(response.data.data.confirm)){self.dissentSendStatus = true}else{self.dissentSendStatus = false}
                                })
                            }else{
                                self.userParyLoading = false
                                self.partybookbVisual = false
                                self.diatorTitle = '无异议调解方案'
                                self.getBookData('NO_DISSENT_MEDIATION_SCHEME')
                            }
                        })
                    }
                }else {
                    this.$message.error(res.data.message)
                    this.userParyLoading = false
                }
            },(error)=>{
                console.log(error)
            })
        },
        partyConfirmBook(type) { // 当事人同意承诺书
            this.buttonStatus = true
            if(type == 'y') {
                agreeProtocolBook({
                    "documentId": this.documentId,
                    "caseId": this.caseId
                }).then((res) => {
                    if(res.data.code === 1000) {
                        this.weixincode = res.data.data+'/sjsodr'
                        this.innerVisible = true
                    }else{
                        this.$message.error(res.data.message);
                    }
                    this.buttonStatus = false
                })
            }else if(type == 'n') {
                refuseProtocolBook({
                    "documentId": this.documentId,
                    "caseId": this.caseId
                }).then((res) => {
                    if(res.data.code === 1000) {
                        this.buttonPromiseResult = 'SIGN_NO'
                        this.closeCurDialog()
                        this.$emit('comcallback')
                    }else{
                        this.$message.error(res.data.message);
                    }
                    this.buttonStatus = false
                })
            }
        },
        agreeBookForm() { // 当事人同意协议书
            this.BtnLoading=true
            this.buttonStatus = true
            // agreeProtocolBook({
            //     "caseId": this.caseId,
            //     "documentId": this.documentId
            // }).then((res) => {
            //     if(res.data.code === 1000) {
            //         this.weixincode = res.data.data+'/sjsodr'
            //         this.innerVisible = true
            //     }else {
            //         this.$message.error(res.data.message)
            //     }
            //     this.BtnLoading=false
            //     this.buttonStatus = false
            // }) 
            if(this.RECORD_MEDIATIONBOOK_type === 'MEDIATION_RECORD') {
                var documentId = this.recordAttaList.find(item=> item.sign === 'MEDIATION_RECORD')
            } else if(this.RECORD_MEDIATIONBOOK_type === 'MEDIATION_BOOK') {
                var documentId = this.recordAttaList.find(item=> item.sign === 'ARBITRATION_BOOK')
            } else if(this.RECORD_MEDIATIONBOOK_type === 'SEND_RECEIPT'){
                var documentId = this.recordAttaList.find(item=> item.sign === 'SEND_RECEIPT')
            } 
            // if (this.RECORD_MEDIATIONBOOK_type === 'MEDIATION_RECORD' || this.RECORD_MEDIATIONBOOK_type === 'MEDIATION_BOOK' || this.RECORD_MEDIATIONBOOK_type === 'SEND_RECEIPT') {
            //     // 开启定时器轮询接口
            //     this.timer = setInterval(this.updateRecordSignStatusRepeat, 1000)
            // }
            clerkConfirmQrCode({
                docId: documentId.docId
            },this.comdata.invite).then(res => {
                if(res.data.code == 1000){
                    this.innerVisible = true
                    this.BtnLoading=false
                    this.buttonStatus = false
                    this.weixincode = res.data.data.launchSign+'/gzzc'
                }
            },erro =>{

            })
        },
        updateRecordSignStatusRepeat() {
            //获取笔录材料
            clerkRecordAttaList({
                objectId: this.meetingId,
                objectType: 'MEDIATION'
            },this.comdata.invite).then(res =>{
               let list = res.data.data
               console.log(this.comdata)
               list.map(item => {
                   // 规则替换
                   if (item.sign == 'ARBITRATION_BOOK') {
                       item.tempSign = 'MEDIATION_BOOK'
                   } else {
                       item.tempSign = item.sign
                   }
                   console.log(this.dialogType, item.tempSign)
                   if (this.dialogType == item.tempSign) {
                       let signedList = item.docOpinionList
                       if (signedList && signedList.length) {
                            signedList.map(item => {
                                if (item.userId == this.comdata.userID) {
                                    this.buttonResult = 'SIGN_YES'
                                    this.innerVisible = false
                                    clearInterval(this.timer)
                                }
                            })
                        }
                   }
               })
            },erro =>{

            })
        },
        refuseBookForm() { // 当事人拒绝协议书
            this.BtnLoading=true
            this.buttonStatus = true
            if(this.RECORD_MEDIATIONBOOK_type === 'MEDIATION_RECORD') {
                var documentId = this.recordAttaList.find(item=> item.sign === 'MEDIATION_RECORD')
            } else {
                var documentId = this.recordAttaList.find(item=> item.sign === 'ARBITRATION_BOOK')
            }
            refuseProtocolBook({
                id: documentId.docId
            }).then((res) => {
                if(res.data.code === 1000) {
                    this.buttonResult = 'SIGN_NO'
                    this.$emit('comcallback')
                }else {
                    this.$message.error(res.data.message)
                }
                this.BtnLoading=false
                this.buttonStatus = false
            })
        },
        submitDissent() { // 当事人查看异议书
            this.diatorTitle = '异议书'
            this.dissentStatus=true
            viewMediationDissent({
                "lawCaseId": this.caseId
            }).then((res) => {
                if(res.data.code === 1000) {
                    this.dissentData = res.data.data
                    this.documentId = res.data.data.documentId
                    this.dissentData.areaarray = Array(res.data.data.provCode,res.data.data.cityCode,res.data.data.areaCode,res.data.data.streetCode)
                }else {
                    this.$message.error(res.data.message)
                }
            })
        },
        saveDissentForm(formName) { // 当事人保存异议书
            this.buttonStatus = true;
            this.saveBtnLoading=true;
            this.dissentData.mediationSchemeId = this.mediationSchemeId
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    saveMediationDissent(this.dissentData).then((res) => {
                        if(res.data.code === 1000) {
                            this.documentId = res.data.data.documentId
                            this.$message({message: '保存成功',type: 'success'})
                            this.closeCurDialog()
                        }else{
                            Boolean(res.data.message)?this.$message.error(res.data.message):'';
                        }
                        this.saveBtnLoading=false;
                        this.buttonStatus = false
                    })
                } else {
                    this.saveBtnLoading=false;
                    this.buttonStatus =  false;
                    return false;
                }
            })
        },
        sendDissentForm(formName) { // 当事人发送异议书
            this.buttonStatus = true;
            this.BtnLoading=true;
            this.dissentData.mediationSchemeId = this.mediationSchemeId
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    sendMediationDissent(this.dissentData).then((res) => {
                        if(res.data.code === 1000) {
                            this.documentId = res.data.data.documentId
                            this.weixincode = res.data.data.launchSign+'/sjsodr'
                            this.innerVisible = true
                        }else{
                            Boolean(res.data.message)?this.$message.error(res.data.message):'';
                        }
                        this.BtnLoading=false;
                        this.buttonStatus = false
                    })
                } else {
                    this.BtnLoading=false;
                    this.buttonStatus =  false
                    return false;
                }
            });
        },
        resetComponentAreaData() {
            this.protocolBookData = {}
        },
        closeCurDialog() {
            this.dialogVisible = false
        },
        sendout() { // 查询某用户对调解文书的签名状态
            this.BtnLoading=true
            getMediationClerkConfirm({
                "docmentId": this.documentId,
                "lawCaseId": this.caseId,
            }).then((res) => {
                if(res.data.code === 1000) {
                    if(res.data.data.confirm){
                        this.innerVisible = false
                        if(this.dialogType == 'NO_DISSENT_MEDIATION_SCHEME'&&!this.dissentStatus){
                            this.partybookbVisual = false
                            this.diatorTitle = '无异议调解方案'
                            this.$emit('comcallback',{type:this.dialogType})
                            this.getBookData('NO_DISSENT_MEDIATION_SCHEME')
                        }else{
                            this.dialogVisible = false
                            this.$emit('comcallback')
                        }
                    }else{
                        this.$message.error('还没有完成签名')
                    }
                }else {
                    this.$message.error(res.data.message)
                }
                this.BtnLoading=false
            })
        },
        handleClose(done) {
            // this.buttonStatus =  true
            // getMediationClerkConfirm({
            //     "docmentId": this.documentId,
            //     "lawCaseId": this.caseId,
            // }).then((res) => {
            //     if(res.data.code === 1000) {
            //         if(res.data.data.confirm){
                        this.innerVisible = false
                        // this.dialogVisible = false
            //         }else{
            //             this.$message({message: '还没有完成签名',type: 'warning'})
            //         }
            //     }else {
            //         if(res.data.message) this.$message.error(res.data.message)
            //     }
            //     done()
            //     this.buttonStatus =  false
            // },(error) => {
            //     done()
            //     this.buttonStatus =  false
            // })
        },
        comAreaBack(opt) {
            if(opt.type == "app") {
                this.protocolBookData.applicantList[opt.index].provCode = opt.code[0]
                this.protocolBookData.applicantList[opt.index].cityCode = opt.code[1]
                this.protocolBookData.applicantList[opt.index].areaCode = opt.code[2]
                this.protocolBookData.applicantList[opt.index].streetCode = opt.code[3]
                this.protocolBookData.applicantList[opt.index].provName = opt.names[0]
                this.protocolBookData.applicantList[opt.index].cityName = opt.names[1]
                this.protocolBookData.applicantList[opt.index].areaName = opt.names[2]
                this.protocolBookData.applicantList[opt.index].streetName = opt.names[3]
            }else if(opt.type == "res"){
                this.protocolBookData.respondentList[opt.index].provCode = opt.code[0]
                this.protocolBookData.respondentList[opt.index].cityCode = opt.code[1]
                this.protocolBookData.respondentList[opt.index].areaCode = opt.code[2]
                this.protocolBookData.respondentList[opt.index].streetCode = opt.code[3]
                this.protocolBookData.respondentList[opt.index].provName = opt.names[0]
                this.protocolBookData.respondentList[opt.index].cityName = opt.names[1]
                this.protocolBookData.respondentList[opt.index].areaName = opt.names[2]
                this.protocolBookData.respondentList[opt.index].streetName = opt.names[3]
            }else if(opt.type == "dissent") {
                this.dissentData.provCode = opt.code[0]
                this.dissentData.cityCode = opt.code[1]
                this.dissentData.areaCode = opt.code[2]
                this.dissentData.streetCode = opt.code[3]
                this.dissentData.provName = opt.names[0]
                this.dissentData.cityName = opt.names[1]
                this.dissentData.areaName = opt.names[2]
                this.dissentData.streetName = opt.names[3]
            }
        },
        handleRecordAttaList(meetingID) {
            //获取笔录材料
            clerkRecordAttaList({
                objectId: meetingID,
                objectType: 'MEDIATION'
            },this.comdata.invite).then(res =>{
               this.recordAttaList = res.data.data
               let list = res.data.data
               list.map(item => {
                   // 规则替换
                   if (item.sign == 'ARBITRATION_BOOK') {
                       item.tempSign = 'MEDIATION_BOOK'
                   } else {
                       item.tempSign = item.sign
                   }
                   if (this.dialogType == item.tempSign) {
                       let signedList = item.docOpinionList
                       if (signedList && signedList.length) {
                            signedList.map(item => {
                                if (item.userId == this.comdata.userID) {
                                    this.buttonResult = 'SIGN_YES'
                                }
                            })
                        }
                   }
               })
               this.userParyLoading = false
            },erro =>{

            })
        },
        downRecordFile(item){
            //下载仲裁调解书
            filedownload('/gzzc/clerkRecord/getClerkRecordMaterial',{
                id: item.id,
            },item.fileName)
        },
    }
}
</script>
<style lang="scss" scoped>
    .mediatbook {
        .caseno {
            height: 30px;
            margin-bottom: 12px;
            line-height: 30px;
            text-align: right;
            .el-input {
                width: 150px;
            }
            .el-input--small .el-input__inner {
                height: 30px;
                line-height: 30px;
            }
        }
        .recordAttaList {
            .el-row {
                display: flex;
                align-items: center;
            }
        }
        .md-head {
            height: 30px;
            margin-bottom: 12px;
            line-height: 30px;
            text-align: right;
            > span {
                float: left;
                font-size: 14px;
                font-weight: bold;
            }
            .el-input {
                width: 150px;
            }
            .el-input--small .el-input__inner {
                height: 30px;
                line-height: 30px;
            }
        }
        .md-wrap {
            /deep/ .el-cascader {
                width: 100%
            }
        }
        .dissentDialog {
            padding-top: 15px;
        }
    }
</style>

